package com.cybersoftsolution.cybersoftsolutionweb.components.menus

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.cybersoftsolution.cybersoftsolutionweb.components.navigation.AdminNavigationItems
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.CloseButtonX
import com.cybersoftsolution.cybersoftsolutionweb.components.navigation.HomeNavigationItems
import com.cybersoftsolution.cybersoftsolutionweb.components.sidePanels.unselectedColor
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateX
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.icons.fa.FaBars
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh


    @Composable
    fun MainMenuOverFlow(onMenuCloseClick: () -> Unit = {}){
        val scope = rememberCoroutineScope()
        val context = rememberPageContext()
        val breakpoint = rememberBreakpoint()

        var translateX by remember {
            mutableStateOf((-100).percent)

        }
        var opacity by remember {
            mutableStateOf((0).percent)

        }

        LaunchedEffect(Unit) {
            translateX = 0.percent
            opacity = 100.percent

//
//            if (breakpoint >= Breakpoint.MD) {
//                translateX = (-100).percent
//                opacity = 0.percent
//
//                onMenuCloseClick()
//            }
        }

        Box(
            modifier = Modifier
                .opacity(opacity)
                .transition(
                    Transition.of(
                        property = "opacity",
                        duration = 500.ms,
                        timingFunction = null,
                        delay = null
                    )
                )
                .fillMaxWidth()
                .height(100.vh)
                .position(Position.Fixed)
                .zIndex(11)
                .backgroundColor(Theme.HalfBlack.rgb)
                .onClick {
                    scope.launch {
                        translateX = (-100).percent
                        opacity = 0.percent
                        delay(500)
                        onMenuCloseClick()
                    }


                }

        ) {

            Column(
                modifier = Modifier
                    .translateX(translateX)
                    .padding(12.px)
                    .borderRadius(
                        bottomRight = 25.px,
                        topRight = 25.px,
                    )
                    .border(
                        width = 1.px,
                        style = LineStyle.Solid,
                        color = Theme.HalfBlack.rgb
                    )
                    .fillMaxHeight()
                    .backgroundColor(Theme.Primary.rgb)
                    .width(
                        if (breakpoint <= Breakpoint.MD) 80.percent
                        else 25.percent
                    )

            ){
                CloseButtonX {

                    scope.launch {
                        translateX = (-100).percent
                        opacity = 0.percent
                        delay(600)
                        onMenuCloseClick()
                    }
                }

                Row (
                    modifier = Modifier
                        .fillMaxWidth()
                        .margin(bottom = 30.px,top = 30.px)
                    ,
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.Center
                ){
                    FaBars(
                        modifier = Modifier
                            .color(unselectedColor),
                        size = IconSize.XL,
                    )


                    SpanText(
                        modifier = Modifier
//                        .fillMaxWidth()
                            .margin(left = 10.px)

                            .color(unselectedColor)
                            .fontSize(14.px),

                        text = "Menu Principal",


                        )
                }



                HomeNavigationItems(context = context)


            }

        }




    }